import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryKeys, requestCCApi } from 'src/utils';

import { IDyTemplate, mapDyTemplates } from './helper';

export const useGetDyTemplates = (
  withConfigs: boolean = false,
  overrideQuerySetting?: UseQueryOptions<IDyTemplate[]>,
) =>
  useQuery({
    queryKey: queryKeys.dyTemplates.all([`withConfigs=${withConfigs}`]),
    queryFn: () => fetchDyTemplates(withConfigs),
    staleTime: Infinity,
    ...overrideQuerySetting,
  });

export const fetchDyTemplates = async (
  withConfigs: boolean = false,
): Promise<IDyTemplate[]> => {
  const url = `/dyTemplates?withConfigs=${withConfigs}`;

  const response = await requestCCApi({ url });

  return mapDyTemplates(response);
};
